import { Image } from '@mantine/core';
import dashboardGIF from '../../public/images/illustrations/animated/dashboard.gif';

const AnimatedIllustrationGIFMap: Record<string, string> = {
	dashboard: dashboardGIF,
};

export type AnimatedIllustrationGIFNames =
	keyof typeof AnimatedIllustrationGIFMap;

type AnimatedIllustrationProps = {
	size: number;
	name: AnimatedIllustrationGIFNames;
};

export function AnimatedIllustration({
	name,
	size,
}: AnimatedIllustrationProps) {
	return (
		<Image
			src={AnimatedIllustrationGIFMap[name]}
			width={size}
			alt={`${name} illustration`}
		/>
	);
}
